<template>
  <AppContainer id="app-payment-methods">
    <PaymentSelectionItem id="pm-balance-selection" @click="handleBalanceSelected"
      :selected="selectedMethod == EPaymentType.balance">
      <BalancePaymentItem :balance="currentBalance" />
    </PaymentSelectionItem>

    <button @click="goToAddBalance" id="add-pix-balance" class="btn btn-link btn-sm text-primary mb-4 ps-0"><i class="fas fa-plus me-2"></i>
      Adicionar saldo com
      pix</button>

    <PaymentSelectionItem id="pm-card-selection" @click="handleCardSelected"
      :selected="selectedMethod == EPaymentType.credit_card">
      <CreditCardPaymentItem :info="lastSelectedCard" />
    </PaymentSelectionItem>

    <button @click="handleAddOrUpdateCard" id="add-update-card" class="btn btn-link btn-sm text-primary mb-2 ps-0"><i
        class="fas fa-plus me-2"></i>
      Adicionar ou alterar
    </button>
    <div class="px-3 py-4 w-100" id="select-pm-container">
      <SubmitBtn title="Selecionar" class="w-100" @click="handlePaymentConfirmed" />
    </div>
  </AppContainer>
</template>

<script lang="ts" setup>
import BalancePaymentItem from '@/components/BalancePaymentItem.vue';
import CreditCardPaymentItem from '@/components/CreditCardPaymentItem.vue';
import { EOffcanvasPage } from '@/components/Offcanvas/canvas.pages';
import useOffCanvas from '@/components/Offcanvas/useOffCanvas';
import PaymentSelectionItem from '@/components/PaymentSelectionItem.vue';
import useCards from '@/composables/useCards';
import usePayment from '@/composables/usePayment';
import useToast from '@/composables/useToast';
import useUser from '@/composables/useUser';
import { EPaymentType } from '@/enums';
import { onMounted, ref } from 'vue';

const {
  currentPaymentMethod,
  currentBalance,
  savePaymentMethod,
} = usePayment()

const { getCards, lastSelectedCard } = useCards()
const {toastError} =useToast()
const { syncUser } = useUser()

const selectedMethod = ref<EPaymentType | null>()
if (currentPaymentMethod.value) {
  selectedMethod.value = currentPaymentMethod.value.payment_type
}
const { navigateCanvas, closeCanvas } = useOffCanvas()

const handleBalanceSelected = () => {
  if (currentBalance.value > 0) {
    selectedMethod.value = EPaymentType.balance
  }
}
const handleCardSelected = () => {
  if (lastSelectedCard.value) {
    selectedMethod.value = EPaymentType.credit_card
  }
}

const handleAddOrUpdateCard = () => {
  if (!currentPaymentMethod.value) {
    return goToAddCards()
  }
  goToCardsList()
}

const goToAddCards = () => {
  navigateCanvas(EOffcanvasPage.add_card)
}
const goToCardsList = () => {
  navigateCanvas(EOffcanvasPage.credit_cards)
}
const goToAddBalance = () => {
  navigateCanvas(EOffcanvasPage.add_balance)
}

const handlePaymentConfirmed = () => {
  if (!selectedMethod.value) {
    toastError('Selecione um  método de pagamento')
    return false
  }
  if (selectedMethod.value == EPaymentType.balance) {
    savePaymentMethod({ payment_type: EPaymentType.balance, card_info: null })
  } else {
    savePaymentMethod({ payment_type: EPaymentType.credit_card, card_info: lastSelectedCard.value })
  }
  closeCanvas()
}

onMounted(() => {
  syncUser()
  getCards()
})

</script>
<style scoped>
#select-pm-container{
    bottom: 0;
    position: absolute;
    left: 0;
}
</style>
